import { render, staticRenderFns } from "./BulkResolveNotificationStatus.vue?vue&type=template&id=a1bd2b1e&"
import script from "./BulkResolveNotificationStatus.vue?vue&type=script&lang=js&"
export * from "./BulkResolveNotificationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports